import React from "react";
import Dialog from "@material-ui/core/Dialog";
import PropTypes from "prop-types";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  button: {
    marginTop: 15,
    color: "#009688",
    float: "right"
  }
});

function SkipDialog(props) {
  const { classes } = props;
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="permission-alert-dialog-title"
      aria-describedby="permission-alert-dialog-description"
    >
      <DialogTitle id="permission-alert-dialog-title">
        {props.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="permission-alert-dialog-description">
          {props.text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={props.onSkip}
          className={classes.button}
          color="primary"
        >
          Skip Without Saving
        </Button>
        <Button
          onClick={props.onSave}
          className={classes.button}
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SkipDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};
export default withStyles(styles)(SkipDialog);



// WEBPACK FOOTER //
// ./src/components/SkipDialog.jsx